/**
 * The api's addresses. Subdomain-first: the api lives on its own host
 * in every deployed environment; localhost only as the dev default.
 */
export const API_BASE = import.meta.env.VITE_API_BASE ?? 'http://localhost:8000';
export const WS_URL = import.meta.env.VITE_WS_URL ?? 'ws://localhost:8000/ws/events';
